import React from 'react';
import Reasons from './Reasons';
import TopBanner from './TopBanner';
import BottomBanner from './BottomBanner';

const AffiliateProgram = () => {
    return (
        <div className="st-affiliate">
            <TopBanner />
            <Reasons />
            <BottomBanner />
        </div>
    );
};

export default AffiliateProgram;